/** A bracketed matrix of ready-made text cells (exact numbers with radicals, decimals). */
export function TextMatrix({
  cells,
  label,
}: {
  cells: readonly (readonly string[])[];
  label: string;
}) {
  return (
    <div className="inline-block max-w-full overflow-x-auto align-middle">
      <table
        aria-label={label}
        className="border-collapse border-foreground/70 border-x-2 font-mono text-foreground text-sm"
      >
        <tbody>
          {cells.map((row, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: matrix rows are positional
            <tr key={i}>
              {row.map((cell, j) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: matrix cells are positional
                <td className="px-2.5 py-0.5 text-right tabular-nums" key={j}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
